import React, { useContext } from 'react'

export interface ShowOverlayProps {
  showOverlay: boolean
  onOverlayClick: () => void
}

export const ScrollPositionContext = React.createContext<{
  showOverlay: ShowOverlayProps
  setShowOverlay: (showOverlay: ShowOverlayProps) => void
}>({
  setShowOverlay: () => {},
  showOverlay: {
    showOverlay: false,
    onOverlayClick: () => {}
  }
})

export const useSetShowOverlay = (): ((showOverlay: ShowOverlayProps) => void) => {
  const { setShowOverlay } = useContext(ScrollPositionContext)
  return setShowOverlay
}

export const useShowOverlay = (): boolean => {
  const { showOverlay } = useContext(ScrollPositionContext)
  return showOverlay.showOverlay
}

export const useOnShowOverlayClick = (): (() => void) => {
  const { showOverlay } = useContext(ScrollPositionContext)
  return showOverlay.onOverlayClick
}
